// ★upd start matsunaga 
// export const APP_NAME = "Generative AI Playground";
export const APP_NAME = "Local LLM Playground";
// ★upd end
export const API_NAME = "api";
